import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative pb-4 mb-8 mt-4" }
const _hoisted_2 = {
  class: "relative block p-3 border-2 border-gray-200 rounded-lg",
  for: "name"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "text-xs font-medium text-gray-500",
  for: "name"
}, " Your Response ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "block px-7 py-1 text-sm font-medium bg-white rounded-full hover:bg-transparent" }, " Reply ", -1)
const _hoisted_5 = [
  _hoisted_4
]

import { usePostStore } from "@/stores/posts";
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  post_id: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props


const content = ref("");
const posts = usePostStore();
const postReply = async () => {
  if (content.value !== "") {
    await posts.make_comment(props.post_id, content.value);
    content.value = "";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _hoisted_3,
      _withDirectives(_createElementVNode("input", {
        class: "w-full p-0 text-sm border-none focus:ring-0",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
        type: "text",
        placeholder: "Start Typing Here"
      }, null, 512), [
        [_vModelText, content.value]
      ])
    ]),
    _createElementVNode("button", {
      onClick: postReply,
      class: "absolute right-0 mt-1 p-[2px] rounded-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 hover:text-white active:text-opacity-75 focus:outline-none focus:ring"
    }, _hoisted_5)
  ]))
}
}

})